import PostStructure from "../Constants/PostStructure"; // adjust path

export const FetchPostData = async () => {
  try {
    const response = await fetch("/api/mock/PostPage/PostPageMockData.json");
    const data = await response.json();

    // Build a single formatted post object
    const formattedPost = {
      ...PostStructure,
      postId: data.post.postId || "",
      userId: data.post.userId || "",
      useruuid: data.post.useruuid || "",
      userimage: data.post.userimage || "",
      descriptions: data.post.descriptions || "",
      timestamp: data.post.timestamp || "",
      location: data.post.location || "",
      nlikes: data.post.nlikes || 0,

      medias: (data.post.medias || []).map((media) => ({
        mediatype: media.mediatype || "",
        mediaurl: media.mediaurl || "",
        nlikes: media.nlikes || 0,
        comments: (media.comments || []).map((c) => ({
          userId: c.userId || "",
          comment: c.comment || "",
          timestamp: c.timestamp || "",
          location: c.location || "",
        })),
        nshares: media.nshares || 0,
        nsuggests: media.nsuggests || 0,
      })),

      comments: (data.post.comments || []).map((c) => ({
        userId: c.userId || "",
        comment: c.comment || "",
        timestamp: c.timestamp || "",
        location: c.location || "",
      })),

      nshares: data.post.nshares || 0,
    };

    return formattedPost;
  } catch (error) {
    console.error("Failed to fetch post data:", error);
    return { ...PostStructure }; // fallback with empty structure
  }
};
